module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left--white-336b3bc6365d92a369f7b3fb0bc7922a.svg";